import ConfigProvider from '../config-provider';
import { log } from '../util';
import Dialog from './dialog';
import StepDialog from './step-dialog';
import StepView from './step-view';
import Inner from './inner';
import { show, notice, warning, error, success } from './show';

Dialog.Inner = ConfigProvider.config(Inner);
Dialog.StepDialog = StepDialog;
Dialog.StepView = StepView;
Dialog.show = config => {
  const { warning: ctxWarning } = ConfigProvider.getContextProps(config, 'Dialog');
  if (ctxWarning !== false) {
    config = processProps(config, log.deprecated);
  }
  return show(config);
};
Dialog.notice = config => {
  const { warning: ctxWarning } = ConfigProvider.getContextProps(config, 'Dialog');
  if (ctxWarning !== false) {
    config = processProps(config, log.deprecated);
  }
  return notice(config);
};
Dialog.warning = config => {
  const { warning: ctxWarning } = ConfigProvider.getContextProps(config, 'Dialog');
  if (ctxWarning !== false) {
    config = processProps(config, log.deprecated);
  }
  return warning(config);
};
Dialog.error = config => {
  const { warning: ctxWarning } = ConfigProvider.getContextProps(config, 'Dialog');
  if (ctxWarning !== false) {
    config = processProps(config, log.deprecated);
  }
  return error(config);
};
Dialog.success = config => {
  const { warning: ctxWarning } = ConfigProvider.getContextProps(config, 'Dialog');
  if (ctxWarning !== false) {
    config = processProps(config, log.deprecated);
  }
  return success(config);
};

/* istanbul ignore next */
function processProps(props, deprecated) {
  if ('closable' in props) {
    deprecated('closable', 'closeable', 'Dialog');
    const { closable, ...others } = props;
    props = { closeable: closable, ...others };
  }

  const overlayPropNames = [
    'target',
    'offset',
    'beforeOpen',
    'onOpen',
    'afterOpen',
    'beforePosition',
    'onPosition',
    'cache',
    'safeNode',
    'wrapperClassName',
    'container',
  ];
  overlayPropNames.forEach(name => {
    if (name in props) {
      deprecated(name, `overlayProps.${name}`, 'Dialog');
      const { overlayProps, ...others } = props;
      const newOverlayProps = {
        [name]: props[name],
        ...(overlayProps || {}),
      };
      delete others[name];
      props = { overlayProps: newOverlayProps, ...others };
    }
  });

  return props;
}

export default ConfigProvider.config(Dialog, {
  transform: (props, deprecated) => {
    return processProps(props, deprecated);
  },
});
